// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1cYqJ","balanceDisclaimer":"posDashboard_balanceDisclaimer__1kR1g"};